/** @jsx h */
import { h } from 'preact'

const PlayIcon = () => (
  <svg width={32} height={16} viewBox='0 0 16 16'>
    <defs>
      <filter
        x='-9%'
        y='-64.6%'
        width='118.1%'
        height='229.2%'
        filterUnits='objectBoundingBox'
        id='PlayIcon-a'
      >
        <feOffset dy={8} in='SourceAlpha' result='shadowOffsetOuter1' />
        <feGaussianBlur
          stdDeviation={4}
          in='shadowOffsetOuter1'
          result='shadowBlurOuter1'
        />
        <feColorMatrix
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0'
          in='shadowBlurOuter1'
          result='shadowMatrixOuter1'
        />
        <feMerge>
          <feMergeNode in='shadowMatrixOuter1' />
          <feMergeNode in='SourceGraphic' />
        </feMerge>
      </filter>
    </defs>
    <g
      filter='url(#PlayIcon-a)'
      transform='translate(-202 -16)'
      fill='none'
      fillRule='evenodd'
    >
      <g transform='translate(210 16)'>
        <circle fill='#000' cx={8} cy={8} r={8} />
        <path
          class='PlayIcon-arrow'
          d='M6 5.135v5.73a1 1 0 0 0 1.64.768l3.438-2.865a1 1 0 0 0 0-1.536L7.64 4.367A1 1 0 0 0 6 5.135z'
          fill='#FFF'
        />
      </g>
    </g>
  </svg>
)

export default PlayIcon
